import React, { useEffect, useState } from "react";
import Header from "./Header";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";

import PostModal from "./PostModal";
import { useNavigate } from "react-router-dom";

import { apiURL } from "../../api";

function Posts(props) {
  const [isPostModal, setIsPostModal] = useState(false);
  const [operation, setOperation] = useState("");
  const [postId, setPostId] = useState("");
  const [message, setMessage] = useState("");

  function closePostModal() {
    setIsPostModal(false);
  }

  const Navigate = useNavigate();
  const adminDetails = JSON.parse(localStorage.getItem("adminDetails"));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const PostsPageLoaded = async () => {
      try {
        if (adminDetails.email === "" || adminDetails.password === "") {
          Navigate("/admin");
        } else {
          const res = await fetch(
            `${apiURL}/adminposts/${adminDetails.email}/${adminDetails.password}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          await res.json();
        }
      } catch (error) {
        Navigate("/admin");
      }
    };
    PostsPageLoaded();
  }, [Navigate, adminDetails.email, adminDetails.password]);

  function deletePost(id) {
    fetch(`${apiURL}/deletepost/${id}`, {
      method: "GET",
    })
      .then((message) => {
        const messageData = message.json();
        if (messageData) {
          setMessage("The Post has been successfully Deleted");
          setTimeout(() => {
            setMessage("");
          }, 2000);
        } else {
          setMessage("Something Went Wrong");
          setTimeout(() => {
            setMessage("");
          }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);

        setMessage("Server Error");
        setTimeout(() => {
          setMessage("");
        }, 2000);
      });
  }

  return (
    <div className="dark:bg-dark" style={{ minHeight: "100vh" }}>
      {isPostModal && (
        <PostModal
          closePostModal={closePostModal}
          operation={operation}
          postId={postId}
        />
      )}
      {message ? (
        <div className="bg-secondary w-full text-center font-semibold p-2 text-white">
          {message}
        </div>
      ) : null}
      <Header enableDarkMode={props.enableDarkMode} />
      <div>
        <div className="flex-col justify-between items-center text-gray-600">
          <button
            onClick={() => {
              setIsPostModal(true);
              setOperation("create");
            }}
            className="dark:bg-slate-500 dark:text-gray-200 font-semibold text-gray-600 flex justify-center items-center w-[88%] mx-auto px-4 py-2 bg-gray-200 outline-none"
          >
            <MdAdd />
            Add Post
          </button>
          <div className="w-[88%] mx-auto">
            <table className="w-full">
              <thead>
                <tr className="dark:bg-slate-800 dark:text-white bg-background text-gray-800">
                  <th className="py-2 px-4 font-semibold text-left">Title</th>
                  <th className="py-2 px-4 font-semibold">Post</th>
                  <th className="py-2 px-4 font-semibold">Edit</th>
                  <th className="py-2 px-4 font-semibold">Remove</th>
                </tr>
              </thead>
              <tbody className="dark:bg-slate-500 dark:text-white">
                {props.posts.map((post) => {
                  const imageArray = new Uint8Array(post.image.data.data);
                  let str = "";
                  for (let i = 0; i < imageArray.length; i++) {
                    str += String.fromCharCode(imageArray[i]);
                  }
                  const base64String = btoa(str);
                  return (
                    <tr className="text-center" key={post._id}>
                      <td className="py-2 px-4 text-left">{post.title}</td>
                      <td className="flex justify-center items-center">
                        <img
                          className="rounded-full"
                          width="40"
                          src={`data:mimeType;base64,${base64String}`}
                          alt="productImag"
                        />
                      </td>
                      <td className="py-2 px-4">
                        <button
                          onClick={() => {
                            setIsPostModal(true);
                            setOperation("update");
                            setPostId(post._id);
                          }}
                        >
                          <MdEdit />
                        </button>
                      </td>
                      <td className="py-2 px-4">
                        <button onClick={() => deletePost(post._id)}>
                          <MdDelete />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Posts;
